export default {"src":"/_next/static/media/bottomArrow.652deb9c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};